module.exports = __webpack_public_path__ + "static/media/mamas-gotchu-logo.9325da21.svg";